module.exports = {
      id: "icon-audio-play-store-usage",
      viewBox: "0 0 122 41",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-audio-play-store",
      toString: function () {
        return this.url;
      }
    }